import React, { useState } from "react";
import styles from "./styles/HelpCenter.module.css";
// eslint-disable-next-line no-unused-vars
import active_styles from "./styles/active.css";
import img1 from "./styles/img/img1.png";
import img2 from "./styles/img/img2.png";
import img3 from "./styles/img/img3.png";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";
import { useAuth } from "../../../Context/AuthContext";
import faqs from "../../../faqs";
import parse from "html-react-parser";
import data from "../../../data/multilanguage.json";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { useEffect } from "react";
export function HelpCenter() {
  window.scrollTo(0, 0);
  const navigate = useNavigate();
  const auth = useAuth();
  const openDropdown = (event) => {
    const panel = event.target.nextElementSibling;

    event.target.classList.toggle("active");
    panel.classList.toggle("active");
    if (panel.classList.contains("active")) {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.style.paddingBottom = "20px";
    } else {
      panel.style.maxHeight = 0;
      panel.style.paddingBottom = 0;
    }
  };
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [homeContent, setHomeContent] = useState(
    websiteCurrentLang.content.home
  );
  const [helpCenterContent, setHelpCenterContent] = useState(
    websiteCurrentLang.content.helpCenterFaq
  );

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setHomeContent(websiteCurrentLang.content.home);
    setHelpCenterContent(websiteCurrentLang.content.helpCenterFaq);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  return (
    <>
      <h1 className={styles.page_title}>{dublicatedcontent.dublicatedText6}</h1>
      <div className={styles.page_with_sidebar}>
        <Sidebar></Sidebar>
        <div className={styles.main}>
          <div className={styles.section}>
            <h2 className={styles.section_title}>{homeContent.homeTitle14}</h2>
            <div className={styles.accordion}>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion1}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer1)}
                </div>
              </div>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion2}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer2)}
                </div>
              </div>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion3}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer3.replaceAll("`", `"`))}
                </div>
              </div>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion4}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer4)}
                </div>
              </div>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion5}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer5)}
                </div>
              </div>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion6}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer6.replaceAll("`", `"`))}
                </div>
              </div>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion7}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer7)}
                </div>
              </div>
              <div className={styles.faq_item}>
                <div
                  data-target="faq-toggle"
                  className={styles.faq_title}
                  onClick={openDropdown}
                >
                  {homeContent.homeFaqQuestion8}
                </div>
                <div className={styles.faq_content}>
                  {parse(homeContent.homeFaqAnswer8)}
                </div>
              </div>
            </div>

            <div className={styles.image_section}>
              <div className={styles.image_title}>
                {helpCenterContent.helpCenterFaqTitle1}
              </div>
              <div className={styles.row}>
                <div
                  className={styles.item}
                  onClick={() =>
                    auth?.otp === true
                      ? navigate("/user/contact-us")
                      : navigate("/contact-us")
                  }
                >
                  <div className={styles.link}>
                    <img alt="" src={img1} className={styles.img} />
                    <div className={styles.subtitle}>
                      {helpCenterContent.helpCenterFaqBox1}
                    </div>
                  </div>
                </div>
                <div
                  className={styles.item}
                  onClick={() =>
                    auth?.otp === true
                      ? navigate("/user/contact-us")
                      : navigate("/contact-us")
                  }
                >
                  <div className={styles.link}>
                    <img alt="" src={img2} className={styles.img} />
                    <div className={styles.subtitle}>
                      {dublicatedcontent.dublicatedText34}
                    </div>
                  </div>
                </div>
                <div
                  className={styles.item}
                  onClick={() =>
                    auth?.otp === true
                      ? navigate("/user/contact-us")
                      : navigate("/contact-us")
                  }
                >
                  <div className={styles.link}>
                    <img alt="" src={img3} className={styles.img} />
                    <div className={styles.subtitle}>
                      {dublicatedcontent.dublicatedText35}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HelpCenter;
